import { NetworkActionErrorCode } from '../../../helpers/types';

export class NetworkActionError extends Error {
  code: NetworkActionErrorCode;

  constructor(message: string, code: NetworkActionErrorCode) {
    super(message);
    this.code = code;
    this.name = this.constructor.name;
    // Non-V8 browsers don't have this property, using it would throw an error on Firefox or Safari
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, this.constructor);
    }
  }
}
